import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { get } from 'lodash';
import DSTruncatedTooltipText from '@elliemae/ds-truncated-tooltip-text';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CustomOption = function CustomOption(_ref) {
  var index = _ref.index,
      data = _ref.data,
      style = _ref.style,
      isScrolling = _ref.isScrolling;
  var items = data.items,
      useTruncatedText = data.options.useTruncatedText;
  var option = items[index];

  var optionProps = _objectSpread(_objectSpread({}, option.props.innerProps), {}, {
    style: style,
    onClick: function onClick(e) {
      e.stopPropagation();
      if (option.props.innerProps.onClick) option.props.innerProps.onClick(e);
    }
  });

  if (useTruncatedText && !isScrolling && get(option, 'props.selectProps.menuIsOpen')) {
    return /*#__PURE__*/React.cloneElement(option, _objectSpread(_objectSpread({}, option.props), {}, {
      innerProps: optionProps
    }), /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
      value: option.props.children
    }));
  }

  return /*#__PURE__*/React.cloneElement(option, _objectSpread(_objectSpread({}, option.props), {}, {
    innerProps: optionProps
  }));
};

export default CustomOption;
//# sourceMappingURL=CustomOption.js.map
